// Store only an internal joining destination, never session credentials.
export function rememberJoin(path) {
  if (/^\/invite\/[A-Za-z0-9_-]+$/.test(path) || path === "/join") {
    sessionStorage.setItem("xps.join.destination", path);
  }
}
export function joinDestination() {
  const path = sessionStorage.getItem("xps.join.destination") || "";
  return /^\/invite\/[A-Za-z0-9_-]+$/.test(path) || path === "/join" ? path : "";
}
export function clearJoin() { sessionStorage.removeItem("xps.join.destination"); }
export function roleHome(user) { return user?.role === "admin" ? "/admin" : user?.role === "athlete" ? "/athlete" : "/coach"; }
export function afterLogin(user) { return joinDestination() || (!user?.role ? "/onboarding" : user.role === "athlete" && !user.consent_accepted ? "/consent" : roleHome(user)); }
